<template>
  <div
    class="layout-menu-loading"
    v-if="loading"
  >
    <c-spinner
      class="logo loading"
      size="md"
    />
  </div>
  <div
    v-else
    class="layout-menu"
  >
    <div class="header">
      <div
        class="profile-picture"
        data-cy="profile-menu-picture"
        @click="editProfile()"
      >
        <c-avatar
          size="lg"
          :image="user.avatar"
        />
      </div>

      <div class="user-info">
        <h3
          class="name"
          @click="editProfile()"
        >
          {{ user.name || user.document }}
        </h3>
      </div>
    </div>

    <wallet-buttons
      v-if="$can('awards') || $can('cashback_tab') || $can('engagement')"
      class="wallet-balances"
      @close="$emit('close')"
    />

    <div class="items">
      <component
        data-cy="profile-menu-items"
        v-for="(item, index) in items"
        class="item -with-border"
        :key="index"
        :is="item.external ? 'a' : 'router-link'"
        :href="item.external ? item.path : null"
        :to="item.external ? null : item.path"
        :target="item.external ? '_blank' : null"
        @click.native="handleLinkClick(item)"
        @mousedown="handleAnalytics(item)"
      >
        <span class="icon">
          <k-icon
            :icon="item.icon"
            size="20"
          />
        </span>
        <p class="name">
          {{ item.name }}
        </p>
        <span class="icon">
          <k-icon
            icon="arrow-right"
            size="10"
          />
        </span>
      </component>
      <div
        v-if="(config.has_api_access && config.logout) || !config.has_api_access"
        data-cy="profile-menu-logout"
        class="item"
        @click="handleAnalytics('Sair'); $emit('logout')"
      >
        <span class="icon">
          <k-icon
            icon="exit-door-log-out2"
            size="15"
          />
        </span>
        <p class="name">
          Sair
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import toMoney from '@helpers/toMoney'
import WalletButtons from './WalletButtons.vue'
import { KIcon } from 'kaledo-components'

export default {
  components: { WalletButtons, KIcon },
  props: {
    user: Object,
    items: [Array, Object],
    config: Object,
    loading: Boolean,
    engagementBalance: Number,
    coin: Object
  },

  computed: {
    userCashbacks () {
      if (!this.user.cashback) return 'R$ 0,00'
      return toMoney(this.user.cashback / 100)
    },
    cantGetCashback () {
      return (this.user.cashback / 100) < 20
    }
  },

  methods: {
    handleLinkClick (item) {
      this.handleAnalytics(item)
      this.$emit('close')
    },
    handleAnalytics (item) {
      const name = item === 'Sair' ? item : item.name

      window.dataLayer.push({
        event: 'Opções do Meu Perfil',
        opcao_clicada_perfil: name
      })
    },

    editProfile () {
      const item = { name: 'Editar perfil' }

      this.handleAnalytics(item)

      this.$router.push({ name: 'Meu perfil' })

      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

$items-group-spacing: 12px;

.layout-menu-loading {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layout-menu {
  width: 300px;
  padding-bottom: 76px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;

  & > .header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 44px;
    background-color: $white-color;
    align-items: center;
    background-image: url('~../../assets/img/pattern-oferta.svg');
    background-repeat: repeat-x;

    & > .profile-picture {
      cursor: pointer;
    }

    & > .user-info {
      text-align: center;

      & > .name {
        font-size: 14px;
        font-family: $title-font-family;
        font-weight: 500;
        color: $text-color;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  & > .wallet-balances {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    width: 200px;
  }

  & > .items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 2px 0;

    & > .item {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 200px;
      height: 32px;
      padding: 8px 4px;
      background-color: $white-color;
      cursor: pointer;

      &.-with-border {
      border-bottom: 1px solid $border-color;
      }

      & > .icon {
        width: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        color: $primary-color-placeholder;
        color: var(--color-primary);
      }

      & > .name {
        width: 100%;
        font-size: 12px;
        text-transform: uppercase;
        margin-left: 16px;
      }

      &:hover { background-color: $hover-background-color; }
    }

    & > a.item { text-decoration: none; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/LayoutMenu.vue